/* eslint-disable no-template-curly-in-string */
import { yup } from 'schemas/validation'
import { pick, isNil } from 'ramda'
import { isUniq } from 'utils/functional'
import strings from 'utils/strings'
import { CAN_INPUT } from 'utils/constants'

import { requiredCan } from './utils'

// checks for unique description field across all feature items that have descriptions
yup.addMethod(yup.string, 'unique', function uniqueWrap(message) {
  return this.test('unique', message, function unique(value) {
    if (!this.options.context) return true

    const { descriptions } = this.options.context

    return (
      isUniq(value, descriptions) ||
      this.createError({
        path: this.path,
        message: strings.unique_description_validation,
      })
    )
  })
})

const inRange = (value, min, max) => value >= min && value <= max

// makes sure the input is in the range of the translated signal
const minMax = (signal, subType, signalsWithTranslations) => {
  if (subType === CAN_INPUT) {
    return {
      minValue: 0,
      maxValue: 65535,
      type: 'range',
    }
  }

  return pick(['minValue', 'maxValue', 'type'], signalsWithTranslations[signal])
}

export const testInputRange = (
  value,
  signal,
  subType,
  context,
  appendToPath = ''
) => {
  if (!context.options.context || (!signal && subType !== CAN_INPUT))
    return true

  const { signalsWithTranslations } = context.options.context

  const { minValue, maxValue, type } = minMax(
    signal,
    subType,
    signalsWithTranslations
  )

  if (type !== 'range') return true

  const valueInRange = inRange(value, minValue, maxValue)

  // check sna and error values for nonboolean signal
  // if error and sna values are not in a range defined input
  // this will fail validation (see line 60)
  const { definedSnaValues = [], definedErrorValues = [] } =
    signalsWithTranslations[signal] || {}

  if (
    definedSnaValues.length > 0 ||
    (definedErrorValues.length > 0 && !valueInRange)
  ) {
    const values = [...definedSnaValues, ...definedErrorValues]
    if (values.includes(value)) {
      return values.includes(value)
    }
  }

  return (
    valueInRange ||
    context.createError({
      path: context.path + appendToPath,
      message: strings.numeric_range_error('range', minValue, maxValue),
    })
  )
}

yup.addMethod(
  yup.number,
  'inInputRange',
  function inInputRangeWrap(signal, subType) {
    return this.test('inInputRange', signal, function inInputRange(value) {
      return testInputRange(value, signal, subType, this)
    })
  }
)

export default yup

export const canItems = {
  canId: yup.string().nullable().when(['queryType', 'description'], {
    is: requiredCan,
    then: yup.string().required(),
  }),
  numberOfBits: yup
    .number()
    .nullable()
    .when('canId', {
      is: (id) => !isNil(id),
      then: yup.number().required(),
    }),
  startBit: yup
    .number()
    .nullable()
    .when('canId', {
      is: (id) => !isNil(id),
      then: yup.number().required(),
    }),
}
